import { useLang } from "@/context";
import { Chapter, Reveal } from "@/components/Reveal";

export default function WorkingStyle() {
  const { t } = useLang();

  return (
    <section data-testid="working-style-section" className="py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <Chapter number={t.style.chapter} label={t.style.label} />
        <Reveal>
          <h2
            data-testid="working-style-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-charcoal font-medium leading-[1.1] mb-16 sm:mb-20"
          >
            {t.style.title}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-0">
          {t.style.items.map((item, i) => (
            <Reveal key={item.word} delay={i * 0.08}>
              <div
                data-testid={`working-style-item-${i}`}
                className={`lg:px-8 ${i === 0 ? "lg:pl-0" : ""} ${
                  i > 0 ? "sm:border-l sm:border-taupe/25 sm:pl-8 lg:pl-8" : ""
                }`}
              >
                <span className="font-serif text-sm text-gold tracking-[0.2em]">0{i + 1}</span>
                <h3 className="mt-4 text-sm sm:text-base uppercase tracking-[0.3em] text-charcoal">
                  {item.word}
                </h3>
                <p className="mt-4 text-sm sm:text-base text-ink/65 font-light leading-relaxed max-w-xs">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
